/// <reference types="@types/google.maps" />

import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, map, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MapsAPILoaderService {

    public loaded: boolean = false;
    public loadedPlaces: boolean = false;

    constructor(public httpClient: HttpClient) {}

    load(): Promise<boolean> {
        if(this.loaded) {
            return Promise.resolve(true);
        }
        const source$ = this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=AIzaSyCzJtE4RRZpv5TqZNJA2S27vNGzOyqGHsg&libraries=places', 'callback')
            .pipe(
                map(() => {
                    this.loaded = true;
                    return this.loaded;
                }),
                catchError(() => of(false)),
            );
        return firstValueFrom(source$);
    }

    loadPlaces(): Promise<boolean> {
        if(this.loadedPlaces) {
            return Promise.resolve(true);
        }

        return google.maps.importLibrary("places").then(() => {
            this.loadedPlaces = true;
            return this.loadedPlaces;
        }, () => false)
    }
}